var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagPanama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0107C0 24.8472 7.1635 32.0107 16 32.0107C16 25.9261 16 16.0107 16 16.0107C16 16.0107 5.56519 16.0107 0 16.0107Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0107422C24.8365 0.0107422 32 7.17424 32 16.0107C25.9153 16.0107 16 16.0107 16 16.0107C16 16.0107 16 5.57593 16 0.0107422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52431 5.57593L10.5604 8.76455H13.9131L11.2007 10.7352L12.2367 13.9238L9.52431 11.9531L6.81193 13.9238L7.84793 10.7352L5.13556 8.76455H8.48825L9.52431 5.57593Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4757 18.0977L23.5117 21.2863H26.8644L24.152 23.2569L25.188 26.4455L22.4757 24.4748L19.7633 26.4455L20.7993 23.2569L18.0869 21.2863H21.4396L22.4757 18.0977Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPanama);
export default __webpack_public_path__ + "static/media/flag_panama.36ddb2041f24731cfea39a994f2ec9e9.svg";
export { ForwardRef as ReactComponent };